import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { SlugProvider } from './context/SlugContext';
import { CouponsProvider } from './context/CouponsContext';
import { AlertProvider } from './context/AlertContext';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <AlertProvider>
        <CouponsProvider>
          <SlugProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </SlugProvider>
        </CouponsProvider>
      </AlertProvider>
    </HelmetProvider>

  </React.StrictMode>,
);
